import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getStock = () => axios.get(`${API}/stock`).then((r) => r.data);

export const bookFabric = (payload) =>
  axios.post(`${API}/book`, payload).then((r) => r.data);

export const placeOrder = (payload) =>
  axios.post(`${API}/order`, payload).then((r) => r.data);

export const getMyOrders = (payload) =>
  axios.post(`${API}/my-orders`, payload).then((r) => r.data);

export const getColors = () => axios.get(`${API}/colors`).then((r) => r.data);
export const getFabrics = () => axios.get(`${API}/fabrics`).then((r) => r.data);
export const getUnits = () => axios.get(`${API}/units`).then((r) => r.data);
const auth = (t) => ({ headers: { Authorization: `Bearer ${t}` } });
export const getAdminUnits = (t) => axios.get(`${API}/admin/units`, auth(t)).then((r) => r.data);
export const addFabric = (t, name, code, unit) => axios.post(`${API}/admin/fabrics/add`, { name, code, unit }, auth(t)).then((r) => r.data);
export const updateFabric = (t, id, name, code, unit) => axios.post(`${API}/admin/fabrics/update`, { id, name, code, unit }, auth(t)).then((r) => r.data);
export const deleteFabric = (t, id) => axios.post(`${API}/admin/fabrics/delete`, { id, name: "", code: "" }, auth(t)).then((r) => r.data);
export const reorderFabrics = (t, ids) => axios.post(`${API}/admin/fabrics/reorder`, { ids }, auth(t)).then((r) => r.data);
export const addUnit = (t, name) => axios.post(`${API}/admin/units/add`, { name }, auth(t)).then((r) => r.data);
export const renameUnit = (t, id, name) => axios.post(`${API}/admin/units/rename`, { id, name }, auth(t)).then((r) => r.data);
export const deleteUnit = (t, id) => axios.post(`${API}/admin/units/delete`, { id }, auth(t)).then((r) => r.data);
export const addColorApi = (t, name, hex) => axios.post(`${API}/admin/colors/add`, { name, hex }, auth(t)).then((r) => r.data);
export const deleteColorApi = (t, id) => axios.post(`${API}/admin/colors/delete`, { id, name: "", hex: "" }, auth(t)).then((r) => r.data);
export const addStockItem = (t, fabric, color, hex, available_kg) => axios.post(`${API}/admin/stock/add`, { fabric, color, hex, available_kg }, auth(t)).then((r) => r.data);
export const deleteStockItem = (t, fabric, color) => axios.post(`${API}/admin/stock/delete`, { fabric, color }, auth(t)).then((r) => r.data);

export const logView = (payload) =>
  axios.post(`${API}/view-log`, payload).then((r) => r.data).catch(() => {});

export const getCatalog = () => axios.get(`${API}/catalog`).then((r) => r.data);

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data);

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getBookings = (token) =>
  axios.get(`${API}/admin/bookings`, authHeader(token)).then((r) => r.data);

export const getOrders = (token, params = {}) => {
  const qs = new URLSearchParams();
  if (params.q) qs.set("q", params.q);
  if (params.status && params.status !== "all") qs.set("status", params.status);
  if (params.from) qs.set("date_from", params.from);
  if (params.to) qs.set("date_to", params.to);
  qs.set("skip", params.skip ?? 0);
  qs.set("limit", params.limit ?? 20);
  return axios.get(`${API}/admin/orders?${qs.toString()}`, authHeader(token)).then((r) => r.data);
};

export const getAdminStock = (token) =>
  axios.get(`${API}/admin/stock`, authHeader(token)).then((r) => r.data);

export const toggleColor = (token, fabric, color, active) =>
  axios
    .post(`${API}/admin/stock/toggle`, { fabric, color, active }, authHeader(token))
    .then((r) => r.data);

export const bulkToggle = (token, targets, active) =>
  axios
    .post(`${API}/admin/stock/bulk-toggle`, { targets, active }, authHeader(token))
    .then((r) => r.data);

export const setOrderStatus = (token, orderId, status) =>
  axios
    .post(`${API}/admin/orders/${orderId}/status`, { status }, authHeader(token))
    .then((r) => r.data);

export const replyToOrder = (token, orderId, reply) =>
  axios
    .post(`${API}/admin/orders/${orderId}/reply`, { reply }, authHeader(token))
    .then((r) => r.data);

export const setStockThreshold = (token, id, min_kg) =>
  axios
    .post(`${API}/admin/stock/threshold`, { id, min_kg }, authHeader(token))
    .then((r) => r.data);

// ----- Suppliers (admin-only) -----
export const getSuppliers = (token) =>
  axios.get(`${API}/admin/suppliers`, authHeader(token)).then((r) => r.data);
export const createSupplier = (token, name) =>
  axios.post(`${API}/admin/suppliers`, { name }, authHeader(token)).then((r) => r.data);
export const toggleSupplier = (token, id) =>
  axios.post(`${API}/admin/suppliers/${id}/toggle`, {}, authHeader(token)).then((r) => r.data);
export const deleteSupplier = (token, id) =>
  axios.delete(`${API}/admin/suppliers/${id}`, authHeader(token)).then((r) => r.data);
export const renameSupplier = (token, id, name) =>
  axios.post(`${API}/admin/suppliers/${id}/rename`, { name }, authHeader(token)).then((r) => r.data);
// ----- Vendor Call Tracker (admin-only) -----
export const getVendorCalls = (token) =>
  axios.get(`${API}/admin/vendor-calls`, authHeader(token)).then((r) => r.data);
export const addVendorCall = (token, entry) =>
  axios.post(`${API}/admin/vendor-calls`, entry, authHeader(token)).then((r) => r.data);
export const updateVendorCall = (token, id, patch) =>
  axios.put(`${API}/admin/vendor-calls/${id}`, patch, authHeader(token)).then((r) => r.data);
export const deleteVendorCall = (token, id) =>
  axios.delete(`${API}/admin/vendor-calls/${id}`, authHeader(token)).then((r) => r.data);
export const getSupplierLines = (token, id) =>
  axios.get(`${API}/admin/suppliers/${id}/lines`, authHeader(token)).then((r) => r.data);
export const saveSupplierLine = (token, id, line) =>
  axios.post(`${API}/admin/suppliers/${id}/line`, line, authHeader(token)).then((r) => r.data);
export const receiveSupplierLine = (token, lineId) =>
  axios.post(`${API}/admin/suppliers/line/${lineId}/receive`, {}, authHeader(token)).then((r) => r.data);

// Customer-safe: arrival dates only
export const getArrivals = () => axios.get(`${API}/arrivals`).then((r) => r.data);

export const getSupplierReceipts = (token, id) =>
  axios.get(`${API}/admin/suppliers/${id}/receipts`, authHeader(token)).then((r) => r.data);
export const undoSupplierReceipt = (token, receiptId) =>
  axios.post(`${API}/admin/suppliers/receipt/${receiptId}/undo`, {}, authHeader(token)).then((r) => r.data);

export const getSupplierLots = (token, id) =>
  axios.get(`${API}/admin/suppliers/${id}/lots`, authHeader(token)).then((r) => r.data);
export const addSupplierLot = (token, id, lot) =>
  axios.post(`${API}/admin/suppliers/${id}/lot`, lot, authHeader(token)).then((r) => r.data);
export const updateSupplierLot = (token, lotId, lot) =>
  axios.put(`${API}/admin/suppliers/lot/${lotId}`, lot, authHeader(token)).then((r) => r.data);
export const receiveSupplierLot = (token, lotId) =>
  axios.post(`${API}/admin/suppliers/lot/${lotId}/receive`, {}, authHeader(token)).then((r) => r.data);
export const deleteSupplierLot = (token, lotId) =>
  axios.delete(`${API}/admin/suppliers/lot/${lotId}`, authHeader(token)).then((r) => r.data);

// Instructions (public read + admin CRUD)
export const getInstructions = () => axios.get(`${API}/instructions`).then((r) => r.data);
export const createInstruction = (token, hi, en) =>
  axios.post(`${API}/admin/instructions`, { hi, en }, authHeader(token)).then((r) => r.data);
export const updateInstruction = (token, id, hi, en) =>
  axios.post(`${API}/admin/instructions/update`, { id, hi, en }, authHeader(token)).then((r) => r.data);
export const deleteInstruction = (token, id) =>
  axios.delete(`${API}/admin/instructions/${id}`, authHeader(token)).then((r) => r.data);

// Customer Database (admin-only)
export const getCustomers = (token, params = {}) => {
  const qs = new URLSearchParams();
  if (params.q) qs.set("q", params.q);
  qs.set("skip", params.skip ?? 0);
  qs.set("limit", params.limit ?? 20);
  return axios.get(`${API}/admin/customers?${qs.toString()}`, authHeader(token)).then((r) => r.data);
};
export const createCustomer = (token, c) =>
  axios.post(`${API}/admin/customers`, c, authHeader(token)).then((r) => r.data);
export const updateCustomer = (token, c) =>
  axios.post(`${API}/admin/customers/update`, c, authHeader(token)).then((r) => r.data);
export const toggleCustomer = (token, id) =>
  axios.post(`${API}/admin/customers/${id}/toggle`, {}, authHeader(token)).then((r) => r.data);
export const deleteCustomer = (token, id) =>
  axios.delete(`${API}/admin/customers/${id}`, authHeader(token)).then((r) => r.data);
export const importCustomers = (token, rows, filename) =>
  axios.post(`${API}/admin/customers/import`, { rows, filename }, authHeader(token)).then((r) => r.data);
export const bulkDeleteCustomers = (token, ids) =>
  axios.post(`${API}/admin/customers/bulk-delete`, { ids }, authHeader(token)).then((r) => r.data);
export const bulkToggleCustomers = (token, ids, active) =>
  axios.post(`${API}/admin/customers/bulk-toggle`, { ids, active }, authHeader(token)).then((r) => r.data);
export const getCustomerDuplicates = (token) =>
  axios.get(`${API}/admin/customers/duplicates`, authHeader(token)).then((r) => r.data);
export const mergeCustomers = (token, ids) =>
  axios.post(`${API}/admin/customers/merge`, { ids }, authHeader(token)).then((r) => r.data);
export const getImportFiles = (token) =>
  axios.get(`${API}/admin/customers/import-files`, authHeader(token)).then((r) => r.data);
export const getImportFile = (token, id) =>
  axios.get(`${API}/admin/customers/import-files/${id}`, authHeader(token)).then((r) => r.data);
export const deleteImportFile = (token, id) =>
  axios.delete(`${API}/admin/customers/import-files/${id}`, authHeader(token)).then((r) => r.data);
export const logExport = (token, filename, count) =>
  axios.post(`${API}/admin/customers/export-log`, { filename, count }, authHeader(token)).then((r) => r.data);
export const getExportFiles = (token) =>
  axios.get(`${API}/admin/customers/export-files`, authHeader(token)).then((r) => r.data);
export const deleteExportFile = (token, id) =>
  axios.delete(`${API}/admin/customers/export-files/${id}`, authHeader(token)).then((r) => r.data);

export const cancelOrder = (token, orderId) =>
  axios
    .post(`${API}/admin/orders/${orderId}/cancel`, {}, authHeader(token))
    .then((r) => r.data);

export const setItemDecision = (token, orderId, itemIndex, decision) =>
  axios
    .post(`${API}/admin/orders/${orderId}/items/${itemIndex}/decision`, { decision }, authHeader(token))
    .then((r) => r.data);

export const getViews = (token) =>
  axios.get(`${API}/admin/views`, authHeader(token)).then((r) => r.data);

export const updateColorApi = (token, id, name, hex) =>
  axios.post(`${API}/admin/colors/update`, { id, name, hex }, authHeader(token)).then((r) => r.data);

export const uploadCatalog = (token, file, title, fabric) => {
  const fd = new FormData();
  fd.append("file", file);
  const q = `title=${encodeURIComponent(title || "")}&fabric=${encodeURIComponent(fabric || "")}`;
  return axios
    .post(`${API}/admin/catalog?${q}`, fd, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data);
};

export const updateCatalog = (token, id, payload) =>
  axios.patch(`${API}/admin/catalog/${id}`, payload, authHeader(token)).then((r) => r.data);

export const deleteCatalog = (token, id) =>
  axios.delete(`${API}/admin/catalog/${id}`, authHeader(token)).then((r) => r.data);

export const uploadFabricImage = (token, fabricId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}/admin/fabrics/${fabricId}/image`, fd, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data);
};

export const deleteFabricImage = (token, fabricId) =>
  axios.delete(`${API}/admin/fabrics/${fabricId}/image`, authHeader(token)).then((r) => r.data);

export const uploadColorImage = (token, colorId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}/admin/colors/${colorId}/image`, fd, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data);
};

export const deleteColorImage = (token, colorId) =>
  axios.delete(`${API}/admin/colors/${colorId}/image`, authHeader(token)).then((r) => r.data);

export const uploadStockImage = (token, fabric, color, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const q = `fabric=${encodeURIComponent(fabric)}&color=${encodeURIComponent(color)}`;
  return axios
    .post(`${API}/admin/stock/image?${q}`, fd, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);
};

export const deleteStockImage = (token, fabric, color) =>
  axios.post(`${API}/admin/stock/image/delete`, { fabric, color }, authHeader(token)).then((r) => r.data);

export const copyStockImageToAll = (token, fabric, color) =>
  axios.post(`${API}/admin/stock/image/copy-to-all`, { fabric, color }, authHeader(token)).then((r) => r.data);

export const renameStockColor = (token, id, new_name) =>
  axios.post(`${API}/admin/stock/rename-color`, { id, new_name }, authHeader(token)).then((r) => r.data);

export const getAnnouncement = () => axios.get(`${API}/announcement`).then((r) => r.data);
export const getAnnouncementAdmin = (token) =>
  axios.get(`${API}/admin/announcement`, authHeader(token)).then((r) => r.data);
export const saveAnnouncement = (token, message, enabled) =>
  axios.post(`${API}/admin/announcement`, { message, enabled }, authHeader(token)).then((r) => r.data);
export const auditStock = (token) =>
  axios.get(`${API}/admin/audit/stock`, authHeader(token)).then((r) => r.data);
export const deleteStockById = (token, id) =>
  axios.post(`${API}/admin/stock/delete-by-id`, { id }, authHeader(token)).then((r) => r.data);

export const bulkDeleteStock = (token, ids) =>
  axios.post(`${API}/admin/stock/bulk-delete`, { ids }, authHeader(token)).then((r) => r.data);

export const restoreStock = (token, items) =>
  axios.post(`${API}/admin/stock/restore`, { items }, authHeader(token)).then((r) => r.data);

export const bulkUploadColorImages = (token, files) => {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append("files", f));
  return axios
    .post(`${API}/admin/colors/bulk-images`, fd, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data);
};

export const getStockHistory = (token, params = {}) => {
  const q = new URLSearchParams();
  if (params.fabric) q.set("fabric", params.fabric);
  if (params.color) q.set("color", params.color);
  if (params.date_from) q.set("date_from", params.date_from);
  if (params.date_to) q.set("date_to", params.date_to);
  return axios.get(`${API}/admin/stock-history?${q.toString()}`, authHeader(token)).then((r) => r.data);
};

export const getSummary = (token) =>
  axios.get(`${API}/admin/summary`, authHeader(token)).then((r) => r.data);

export const setStock = (token, fabric, color, available_kg) =>
  axios
    .post(`${API}/admin/stock/set`, { fabric, color, available_kg }, authHeader(token))
    .then((r) => r.data);

export const refillStock = (token, fabric, color, add_kg) =>
  axios
    .post(`${API}/admin/stock/refill`, { fabric, color, add_kg }, authHeader(token))
    .then((r) => r.data);

// ----- Co-Admin (single account) -----
export const coadminConfig = () =>
  axios.get(`${API}/coadmin/config`).then((r) => r.data);
export const coadminLogin = (email, password) =>
  axios.post(`${API}/coadmin/login`, { email, password }).then((r) => r.data);
export const coadminMe = (token) =>
  axios.get(`${API}/coadmin/me`, authHeader(token)).then((r) => r.data);
export const coadminSearchCustomers = (token, q) =>
  axios.get(`${API}/coadmin/customers?q=${encodeURIComponent(q)}`, authHeader(token)).then((r) => r.data);

// ----- Order item / customer alterations (admin + co-admin) -----
export const adminAlterItem = (token, orderId, index, fabric, color) =>
  axios.post(`${API}/admin/orders/${orderId}/items/${index}/alter`, { fabric, color }, authHeader(token)).then((r) => r.data);
export const coadminAlterItem = (token, orderId, index, fabric, color) =>
  axios.post(`${API}/coadmin/orders/${orderId}/items/${index}/alter`, { fabric, color }, authHeader(token)).then((r) => r.data);
export const adminAlterCustomer = (token, orderId, customerId) =>
  axios.post(`${API}/admin/orders/${orderId}/alter-customer`, { customer_id: customerId }, authHeader(token)).then((r) => r.data);
export const coadminAlterCustomer = (token, orderId, customerId) =>
  axios.post(`${API}/coadmin/orders/${orderId}/alter-customer`, { customer_id: customerId }, authHeader(token)).then((r) => r.data);
export const adminDeleteItem = (token, orderId, index) =>
  axios.post(`${API}/admin/orders/${orderId}/items/${index}/delete`, {}, authHeader(token)).then((r) => r.data);
export const coadminDeleteItem = (token, orderId, index) =>
  axios.post(`${API}/coadmin/orders/${orderId}/items/${index}/delete`, {}, authHeader(token)).then((r) => r.data);
export const adminAcceptAll = (token, orderId) =>
  axios.post(`${API}/admin/orders/${orderId}/accept-all`, {}, authHeader(token)).then((r) => r.data);
export const adminRejectAll = (token, orderId) =>
  axios.post(`${API}/admin/orders/${orderId}/reject-all`, {}, authHeader(token)).then((r) => r.data);
export const adminRestoreItem = (token, orderId, index) =>
  axios.post(`${API}/admin/orders/${orderId}/items/${index}/restore`, {}, authHeader(token)).then((r) => r.data);
export const coadminRestoreItem = (token, orderId, index) =>
  axios.post(`${API}/coadmin/orders/${orderId}/items/${index}/restore`, {}, authHeader(token)).then((r) => r.data);
export const coadminGetStock = (token) =>
  axios.get(`${API}/coadmin/stock`, authHeader(token)).then((r) => r.data);
export const coadminGetCatalog = (token) =>
  axios.get(`${API}/coadmin/catalog`, authHeader(token)).then((r) => r.data);
export const coadminPlaceOrder = (token, payload) =>
  axios.post(`${API}/coadmin/order`, payload, authHeader(token)).then((r) => r.data);
export const coadminGetOrders = (token, params = {}) => {
  const qs = new URLSearchParams();
  if (params.q) qs.set("q", params.q);
  qs.set("skip", params.skip ?? 0);
  qs.set("limit", params.limit ?? 20);
  return axios.get(`${API}/coadmin/orders?${qs.toString()}`, authHeader(token)).then((r) => r.data);
};
export const getCoadminActivity = (token) =>
  axios.get(`${API}/admin/coadmin/activity`, authHeader(token)).then((r) => r.data);
export const amendDelivered = (token, orderId, itemIndex, delivered_kg) =>
  axios.post(`${API}/admin/orders/${orderId}/items/${itemIndex}/delivered`, { delivered_kg }, authHeader(token)).then((r) => r.data);
export const coadminAmendDelivered = (token, orderId, itemIndex, delivered_kg) =>
  axios.post(`${API}/coadmin/orders/${orderId}/items/${itemIndex}/delivered`, { delivered_kg }, authHeader(token)).then((r) => r.data);
export const coadminGetAllOrders = (token, params = {}) => {
  const qs = new URLSearchParams();
  if (params.q) qs.set("q", params.q);
  qs.set("skip", params.skip ?? 0);
  qs.set("limit", params.limit ?? 20);
  return axios.get(`${API}/coadmin/all-orders?${qs.toString()}`, authHeader(token)).then((r) => r.data);
};

// ----- Rates / GST / per-order pricing (admin-only) -----
export const getRates = (token) => axios.get(`${API}/admin/rates`, authHeader(token)).then((r) => r.data);
export const setFabricRate = (token, fabric, rate) => axios.post(`${API}/admin/rates/fabric`, { fabric, rate }, authHeader(token)).then((r) => r.data);
export const setColorRate = (token, fabric, color, rate) => axios.post(`${API}/admin/rates/color`, { fabric, color, rate }, authHeader(token)).then((r) => r.data);
export const setGst = (token, gst) => axios.post(`${API}/admin/rates/gst`, { gst }, authHeader(token)).then((r) => r.data);
export const saveOrderPricing = (token, orderId, payload) => axios.post(`${API}/admin/orders/${orderId}/pricing`, payload, authHeader(token)).then((r) => r.data);
export const getOrderPricingSuggestion = (token, orderId) => axios.get(`${API}/admin/orders/${orderId}/pricing-suggestion`, authHeader(token)).then((r) => r.data);
export const toggleSupplierFabric = (token, supplierId, fabric) => axios.post(`${API}/admin/suppliers/${supplierId}/toggle-fabric`, { fabric }, authHeader(token)).then((r) => r.data);

// ----- Admin role switching + Reports -----
export const adminGetCoadminToken = (token) => axios.post(`${API}/admin/coadmin-token`, {}, authHeader(token)).then((r) => r.data);
export const reportDaily = (token, from, to) => axios.get(`${API}/admin/reports/daily?date_from=${from || ""}&date_to=${to || ""}`, authHeader(token)).then((r) => r.data);
export const reportCustomerStatement = (token, customerId) => axios.get(`${API}/admin/reports/customer-statement/${customerId}`, authHeader(token)).then((r) => r.data);
export const reportCustomerFrequency = (token, customerId) => axios.get(`${API}/admin/reports/customer-frequency/${customerId}`, authHeader(token)).then((r) => r.data);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
